import React, { Component } from "react";
import MainMenu from "../components/mainMenu";
import SubNavigation from "../components/subNavigation";
import TopBanner from "../components/topBanner";
import AnimatedBackground from "../components/animatedBackground";
import InstagramFeed from "../components/instagramFeed";
import Footer from "../components/footer";
import SuitMaterial from "../components/suitMaterial";

export default class SuitLuge extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		document.title = "QwixSkinz || Luge Race Suits";
	}

	componentWillUnmount() {}

	render() {
		return (
			<React.Fragment>
				<MainMenu />
				<TopBanner
					bannerHeight="full"
					title="Luge Suit"
					images={["luge/lugeBanner.jpg"]}
				/>
				<SubNavigation
					location={this.props.location}
					refs={this.refs}
					navItems={[
						{ title: "WC Race Suit", id: "overview" },
						{ title: "Youth Suit", id: "kidsuit" },
						{ title: "Material", id: "material" },
						{ title: "Performance Benefits", id: "performance" }
					]}
				/>
				{/* Luge Suit Overview */}
				<div className="qs-b" ref="overview">
					<div className="container block-wrap behind-trees">
						<div className="d-flex flex-row flex-wrap align-items-stretch">
							<div className="col-12 content dark pb-0">
								<div className="section-title">
									<h1 className="title">Luge World Cup Race Suits</h1>
								</div>
							</div>
							<div className="col-12 content dark pt-0">
								<p className="lead">
									Building on the Qwixskinz reputation for fast race suits, our
									World Cup Luge Race Suit will give any Luge racer the
									advantage when every .001 of a second counts.
								</p>
								<p>
									Specifically placed seams for the best aerodynamic benefits.
									High quality locking zippers in the back &amp; wrists.
								</p>
								<p>Thumbhole &amp; half foot finishes.</p>
								<p>
									2 sizing options available: Stock &amp; Custom sizing only
									available.
								</p>
								<p>
									Custom sizing is either by measurement or, new in 2018, 3D
									athlete modelling for full customization of fit using 3D
									patterning technology.
								</p>
								<p>
									Our original graphics/artwork can be customized for your team
									&amp; sponsor logos can be integrated into the artwork.{" "}
								</p>
								<p>
									Any customization charges will be quoted at the time of order.
								</p>
								<p>
									Team custom designs can be incorporated. Added charges apply.
								</p>
							</div>
						</div>
					</div>
				</div>
				{/* Development Kids Suits */}
				<div className="qs-b" ref="kidsuit">
					<div className="container block-wrap behind-trees">
						<div className="d-flex flex-row flex-wrap align-items-stretch">
							<div className="col-12 content dark pb-0">
								<div className="section-title">
									<h1 className="title">Development / Youth Race Suit</h1>
								</div>
							</div>
							<div className="col-12 content dark pt-0">
								<p className="lead">
									At Qwixskinz we believe that even the youngest of racers
									deserve the best possible quality. In fact, the best quality
									is necessary to take the bumps &amp; hits &amp; still look new for as
									long as possible. Both warmth &amp; durability allow the young
									racer to concentrate on the skills needed to progress in Luge
									racing. Our exclusive fabric used in our Qwixskinz
									Development/Youth Luge race suit is specifically developed
									with an abrasion resistant top layer for exactly this level of
									racer.
								</p>
								<p>
									The development/youth Luge racer has the benefit of the same
									Qwixskinz quality that the World Cup Luge suits provide.
								</p>
								<p>
									Constructed with the same aerodynamic seam placement,
									Qwixskinz utilizes a newly developed fabric, exclusive to our
									race suits to give the Development/Youth Luge racer the chance
									to race in a durable, quality race suit while learning their
									sport.
								</p>
								<ul>
									<li>YYK back zipper (no wrist zippers).</li>
									<li>Thumbhole &amp; stirrup foot finishes.</li>
									<li>Adult &amp; Youth Stock sizing only.</li>
								</ul>
								<p>
									Choose from our original design/artwork (colour customizing,
									personal sponsor logo application &amp; are available at an extra
									charge). Team original design available upon request. Minimum
									orders may apply.
								</p>
							</div>
						</div>
					</div>
				</div>

				{/* Suit Material Section */}
				<SuitMaterial ref="material">
					<React.Fragment>
						<div className="section-title">
							<h1 className="title">Suit Material</h1>
						</div>
						<p className="lead">
							At Qwixskinz, we work with the world’s leading aerodynamic fabric
							mills to choose the best fabric for each application.
						</p>
						<p>
							Our Stock sized Qwixskinz World Cup Luge Race Suit fabric has the
							same 3-layer fabric system expected in all of our Luge race suits
							with an added stretch factor to give the racer the best fit
							possible.
						</p>
						<p>
							Our Custom World Cup Luge Race Suit with our new 3D patterning
							technology allows us to custom fit the racer with the highest
							level of aerodynamic fabrics that have a slightly more restrictive
							stretch &amp; air flow. The customization of the race suit is key with
							this fabric choice as proven by our wind tunnel testing.
						</p>
						<p>
							An exclusive 3-layer fabric that provides wind &amp; water protection
							for the cold training days. With the needs of the development Luge
							racer in mind, Qwixskinz concentrated on the unique performance
							components of our youth race suit. The superior abrasion resistant
							top layer gives the same quality finish as the adult suit,
							allowing for the durability &amp; retention of the “new look” for as
							long as possible while resisting pilling from falls as well as
							Velcro fasteners on gloves, jackets, etc. The same ability to
							print &amp; retain vibrant colours allows the Qwixskinz
						</p>
					</React.Fragment>
				</SuitMaterial>
				
				{/* Performace Section */}
				<div className="qs-b" ref="performance">
					<div className="container block-wrap behind-trees">
						<div className="d-flex flex-row flex-wrap align-items-stretch">
							<div className="col-12 content dark pb-0">
								<div className="section-title">
									<h1 className="title">Performance Benefits</h1>
								</div>
							</div>

							<div className="col-12 content dark pt-0">
								<p className="lead">
									While in every high speed sport aerodynamics matter, in Luge
									the possibility of victory or defeat is .001 of a second, the
									narrowest of all sliding sports!
								</p>
								<p>
									The right combination of superior aerodynamic fabrics, optimal
									seam placement &amp; the perfect fit allows the Luge racer to know
									that EVERY possible advantage is in their race suit when they
									hit the start line. Add to this, Qwixskinz’ vast high speed
									racing knowledge that allows for cross-sport references &amp;
									improvements.
								</p>
								<p>
									Ongoing fabric developments &amp; wind tunnel testing will assure
									that the Qwixskinz Luge Race Suits leave nothing to chance &amp;
									the rest up to the racer.
								</p>
								<hr />
								<h3>Development / Youth Performance Benefits</h3>
								<p className="lead">
									At Qwixskinz we believe that even the youngest of racers
									deserve the best possible quality.
								</p>
								<p>
									In fact, the best quality is necessary to take the bumps &amp;
									hits &amp; still look new for as long as possible. Both warmth &amp;
									durability allow the young racer to concentrate on the skills
									needed to progress in Luge racing.
								</p>
								<p>
									Our exclusive fabric used in our Qwixskinz Development/Youth
									Luge race suit is specifically developed with an abrasion
									resistant top layer for exactly this level of racer.
								</p>
							</div>
						</div>
					</div>
				</div>

				<InstagramFeed  />
				<Footer />
				<AnimatedBackground />
			</React.Fragment>
		);
	}
}
